import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Terminal, History } from "lucide-react";
import { AssistantLogs } from "@/features/Assistant/components/AssistantLogs";
import { AssistantHistory } from "@/features/Assistant/components/AssistantHistory";

// Assistant tab (PBI 81485): terminal Serilog por padrão, com toggle "Histórico"
// que traz o histórico de reuniões (antes na tela de Queues) — mesmo modelo das
// abas Agentic (Chats), Gateway (Tools) e Engine (Agents).

type ViewMode = "logs" | "history";

export const AssistantLogsTab = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ViewMode>("logs");

  const modeButton = (value: ViewMode, label: string, Icon: typeof Terminal) => (
    <button
      type="button"
      aria-pressed={mode === value}
      onClick={() => setMode(value)}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
        mode === value
          ? "bg-background shadow-sm font-medium"
          : "text-muted-foreground hover:text-foreground"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );

  return (
    <Card className="w-full">
      <CardContent className="pt-6 space-y-4">
        <div className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
          {modeButton("logs", t("logs.modes.logs", "Logs"), Terminal)}
          {modeButton("history", t("logs.modes.history", "Histórico"), History)}
        </div>

        {mode === "logs" ? <AssistantLogs /> : <AssistantHistory />}
      </CardContent>
    </Card>
  );
};
